export default __webpack_public_path__ + "static/media/no_avatar.8aa7ad05.svg";